import { Button } from '@american-autonomy/ag-ui';

import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleButton: FunctionComponent<Props> = ({
    className = '',
    onClick,
    testId = TEST_ID,
    text
}) => (
    <Button className={`${styles.toggleButton} ${className}`} onClick={onClick} testId={testId}>
        <LabelText className={styles.labelText} text={text} />
    </Button>
);

export default ToggleButton;
